
import ThemeToggle from './ThemeToggle';
import LogoutButton from './LogoutButton';

export default function Header() {
  return (
    <header className="sticky top-0 z-30 flex items-center justify-between px-6 h-16 bg-white/90 dark:bg-gray-900/90 border-b border-gray-200 dark:border-gray-700 backdrop-blur">
      <div className="font-bold text-lg text-gray-800 dark:text-white tracking-tight">HRMS</div>
      <div className="flex items-center gap-4">
        <ThemeToggle />
        <LogoutButton />
      </div>
    </header>
  );
}
